import { Component } from 'base/webflow/schema';
import { ElementInstance, ElementInstanceState } from 'blocks/editor/model';
import React from 'react';
import { NodeDecorator } from './decorators';
import { getSlotInfoAtNode } from './slots';
import styles from './slot_highligher.css';

const slotContext = React.createContext(false);

/**
 * Decorator to help with React slot tagging by highlighting the slot and element with outlines.
 */
export function getSlotHighlightDecorator({
  element,
  component,
}: {
  element: ElementInstance | ElementInstanceState;
  component: Component;
}): NodeDecorator {
  return function* (node) {
    const slotInfo = getSlotInfoAtNode(node, element.source, component);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isElement = React.useContext(slotContext);
    if (slotInfo) {
      yield {
        className: [styles.slotOutline],
        wrapChildren: (children) =>
          React.Children.count(children) > 0 ? (
            <slotContext.Provider value={true}>{children}</slotContext.Provider>
          ) : (
            children
          ),
      };
    }
    if (isElement) {
      yield {
        className: [styles.elementOutline],
        wrapChildren: (children) =>
          React.Children.count(children) > 0 ? (
            <slotContext.Provider value={false}>
              {children}
            </slotContext.Provider>
          ) : (
            children
          ),
      };
    }
  };
}
